export default "__VITE_ASSET__4tEeR4LX__"